var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61816 4.5H9.38184C9.5712 4.5 9.7444 4.60701 9.8291 4.77637L10.2764 5.6709C10.5305 6.17905 11.05 6.5 11.6182 6.5H12C12.2761 6.5 12.5 6.72386 12.5 7V11C12.5 11.2761 12.2761 11.5 12 11.5H4C3.72386 11.5 3.5 11.2761 3.5 11V7C3.5 6.72386 3.72386 6.5 4 6.5H4.38184C4.94997 6.5 5.46954 6.17904 5.72363 5.6709L6.1709 4.77637C6.2556 4.60701 6.4288 4.5 6.61816 4.5Z",
    stroke: "#002A69"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.5,
    r: 1.5,
    stroke: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.8a96acb4ee787cf5239a2f58e3d44d0b.svg";
export { ForwardRef as ReactComponent };